import React from 'react';
import TeamCard from '../../components/TeamCard';
import BigHeader from '../../components/BigHeader';
import './TeamMembers.css'
import Card from 'react-bootstrap/Card';

const TeamMembers = () => {

    const members = [
        {
            name: "Laure Mourgue d'Algue",
            email: "laurema26@gmail.com",
            role: "Human practices & Wet Lab ",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/laure.png",
            text: "Laure is a current M2 Interdisciplinary Life Sciences masters at Learning Planet Institute. She completed her M1 and undergraduate studies at University College London, specialising in neurodegeneration and immunology, before spending a “gap” year working in public health policy & democratic innovation. Back in academia, she conciles her interest for scientific research with a love for creative writing, arts and whatever life throws her way.",
        },
        {
            name: "Louis Elverston",
            email: "louis.elverston@cri-paris.org",
            role: "Student leader",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/louis.png",
            text: "Currently undertaking M2 life sciences at the LPI with a history of molecular biology. Louis has a keen attractions to all things new and shiny, and finds himself delving into all walks of cutting edge science."
        },
        {
            name: "Milena Milovanović",
            email: "milena.milovanovic@cri-paris.org",
            role: "Student Leader",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/milena.png",
            placement: '100px 100px',
            text: "After completing undergraduate studies in Molecular Biology and Physiology at the University of Belgrade, she moved to Paris for a masters in Interdisciplinary Approaches in Life Sciences at the LPI. It became apparent very early on how much she enjoys talking, which has proven quite useful in her science communication endeavors. When all is said and done, she is just a pop culture connoisseur."
        },
        {
            name: "Avishkar Jadhav",
            role: "Student",
            email: "avishkar.jadhav@cri-paris.org",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/avi.png",
            text: "With both an undergrad and an ongoing masters in life sciences, the only continual interest he has is his obsession with tinkering with everything ranging from the laboratory to musical instruments. "
        },
        {
            name: "Mostafa Elraies",
            email: "mostafa.elraies@cri-paris.org",
            role: "Student",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/mustapha.png",
            placement: '100px 100px',
            text: "Mostafa currently serves as a biologist, despite his foundational training in the field of physics. He obtained his bachelor from the University of Science and Technology at Zewail City, Egypt. In the mean time, he is diligently pursuing a master's degree in life sciences at Université Paris Cité. Beyond his dedicated scientific pursuits, Mostafa harbors a special enthusiasm for the realms of literature, cinema, and writing."
        },
        {
            name: "Staša Rakočević",
            email: "rakocevicstasa@yahoo.com",
            role: "Student",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/stassa.png",
            text: "Staša is currently pursuing a Bachelor's degree in Character Animation and Animated Filmmaking at Gobelins school in Paris, France. She is also a devoted cat-sitter and her own hairstylist."
        },
        {
            name: "Tony Makdissy",
            email: "tony.makdissy@cri-paris.org",
            role: "Student",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/tony.png",
            text: "Tony, a Life Sciences student and pharmacy graduate, can spend a month immersed in games like Sudoku and Solitaire. He is passionate about computational biology and has explored the world of research through an internship at Minc's Lab in the Jacques Monod Institute. Additionally, Tony has participated in the International Physics Olympiad (IPhO) and achieved finalist status in the International Collegiate Programming Contest (ICPC) World Finals."
        },
        {
            name: "Yoann Le Vay",
            email: "yoann.levay@cri-paris.org",
            role: "Student",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/yoann.jpg",
            text: "At the moment, doing a master 1 in Molecular Biology, after finishing a BTS in biotechnology and a license in health biology. Yoann has a natural curiosity for science and especially biology. Thanks to this project he was able to discover the joy of team work and also discover new biological disciplines."
        },
        {
            name: "Dakshayani Pinninti",
            email: "daksh3720@gmail.com",
            role: "Student",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/daksha.jpg",
            text: "Currently pursuing a joint master's in economics at the Paris School of Economics, EHESS, and ENS. She comes from a background in physics, economics, and applied math. With a keen interest in neuroscience and biology, she joined the team excited to apply her knowledge in a field other than economics. Her interests range from concocting cocktails on a random weekday, to designing new business plans just about every other week."
        },
        {
            name: "Hritika Kathuria",
            role: "Web Designer",
            email: "hritika.kathuria@cri-paris.org",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/lll.png",
            text: ""
        }
    ]
    const advisors = [
        {
            name: "Amir Pandi",
            email: "amir.pandi@cri-paris.org",
            role: "Advisor",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/amir.jpg",
            text: "Amir is a postdoc working on cell-free synthetic biology, genetic circuit design and AI-based development of antimicrobial and phase separating peptides. He has previously participated in iGEM as a member (2016), advisor (2017), and mentor (2019).",
        },
        {
            name: "Ariel Lindner",
            email: "ariel.lindner@cri-paris.org",
            role: "PI",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/advisor.jpeg",
            text: "Amir is a postdoc working on cell-free synthetic biology, genetic circuit design and AI-based development of antimicrobial and phase separating peptides. He has previously participated in iGEM as a member (2016), advisor (2017), and mentor (2019).",
        },
        {
            name: "Ernest Mordret",
            email: "ernest.mordret@cri-paris.org",
            role: "Primary advisor",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/ernest.jpg",
            text: "After participating in iGEM in 2012, Ernest decided to pursue his love for microbiology with a PhD in computational biology at the Weizmann Institute, Israel. At the moment a postdoc at the LPI, his current interests include training LLMs for biology and teaching the young bloods how to code.",
        },
        {
            name: "Helena Shomar",
            email: "helena.shomar@cri-paris.org",
            role: "Advisor",
            image: "https://static.igem.wiki/teams/4602/wiki/images/team/helena.jpg",
            text: "Helena is a bioengineer specialized in the field of synthetic biology and microbial metabolism: She program microbes to produce useful chemicals that could advance diverse industry sectors, promote global health or protect the environment, and kindly provided the team with insight on how best to handle entrepreneurship",
        },
    ]
    return (
        <div>
            <BigHeader headerText={'Team Members'} backgroundImage={'https://static.igem.wiki/teams/4602/wiki/images/images/background.jpg'}/>
            <div className='custom-overlay'>
            <div className="team-container">
            {members.map((data, index) => (
                <div>
                <TeamCard key={index}  data={data}/>
                </div>
            ))}
            </div>
            <Card>
            <h1 style={{textAlign:"center"}}>Mentors and Advisors</h1>
            </Card>
            <div className="team-container">
            {advisors.map((data, index) => (
                <div>
                <TeamCard key={index} data={data}/>
                </div>
            ))}
            </div>
            </div>

        </div>
    )
}
export default TeamMembers;
